import { ReactNode } from "react";
import { AppEnum, DomainType, EntityMode, ExportParams, ExportType, SearchCase, SearchOrder } from "@/Shared";
import { ExportFormat } from "@/Domains";

export type ColumnType = 'string' | 'number' | 'date' | 'boolean';


export type FilterField<T> = {
    key: keyof T, value: any
}

export interface Header<VM extends Record<string, any>> {
    key: keyof VM;
    icon : ReactNode;
    label: string;
    type: ColumnType;
    isSortable?: boolean;
    isHidden?: boolean;
    filter?: {
        label: string;
        options?: AppEnum[];
        case? : SearchCase,
        operator? : string
    };
}

export interface EntityCRUD<VM> {
    read?: (itemId: number) => void;
    create?: () => void;
    edit?: (itemId: number) => void;
    delete?: (itemId: number) => Promise<void>;
    restore?: (itemId: number) => Promise<void>;
    generate?: (params: ExportParams<VM>, format: ExportFormat) => Promise<void>;
}

export interface UserActions<VM> {
    domain: DomainType;
    crud: EntityCRUD<VM>;
    domainMode : {
        current : EntityMode,
        toggle : () => void,
        isLoading? : false
    } 
}


export interface DataTableConfig<VM extends Record<string, any>> {
    domainLabel : string;
    headers: Record<keyof VM, Header<VM>>;
    initialData: VM[];
    Icon?: React.ElementType;
    noStickyHeader?: boolean;
    initialBatchCapacity?: BatchCapacity,
    defaultCaseSensitive?: boolean;
    userActions? : UserActions<VM>;
    isRestorable : boolean
    newItems? : number[],
    title? : string,
    headerAction?:  JSX.Element
}

export const DEFAULT_BATCH_CAPACITY = 50;


export const BATCH_CAPACITY_OPTIONS = [10, 25, 50, 100, 500, 1000] as const;
export type BatchCapacity = typeof BATCH_CAPACITY_OPTIONS[number];

export type SortedColumn<VM extends Record<string, any>> = {
	header: Header<VM>,
	order: SearchOrder
}